// Mock Data pour Retour Affectif

export const services = [
  {
    id: 1,
    title: "Retour Affectif Rapide",
    description: "Maître Diamma vous aide à retrouver l'amour et l'harmonie dans votre vie sentimentale grâce à ses puissants rituels ancestraux. Résultats visibles en 24 à 72 heures.",
    icon: "Heart",
    keywords: ["retour affectif rapide", "retour affectif puissant", "rituel amour efficace"]
  },
  {
    id: 2,
    title: "Retour de l'Être Aimé",
    description: "Maître Diamma fait revenir la personne qui compte le plus pour vous. Il utilise des techniques ancestrales transmises de génération en génération.",
    icon: "Users",
    keywords: ["retour être aimé", "faire revenir être aimé", "amour perdu retrouvé"]
  },
  {
    id: 3,
    title: "Retour d'Affection Garanti",
    description: "Maître Diamma rétablit les liens affectifs brisés et vous aide à retrouver la tendresse et l'attention de votre partenaire. Intervention puissante et résultats durables.",
    icon: "HeartHandshake",
    keywords: ["retour affection", "retrouver tendresse", "liens affectifs"]
  },
  {
    id: 4,
    title: "Reconquérir son Ex",
    description: "Vous avez perdu l'amour de votre vie ? Maître Diamma, spécialiste du retour affectif depuis 30 ans, vous aide à reconquérir votre ex définitivement.",
    icon: "Undo2",
    keywords: ["reconquérir ex", "récupérer amour perdu", "deuxième chance amour"]
  },
  {
    id: 5,
    title: "Récupérer son Ex Rapidement",
    description: "Ne laissez pas votre histoire d'amour se terminer. Les rituels puissants de Maître Diamma permettent de récupérer votre ex en un temps record.",
    icon: "RefreshCw",
    keywords: ["récupérer ex rapidement", "retrouver ex vite", "ex revient"]
  },
  {
    id: 6,
    title: "Faire Revenir son Ex en 72h",
    description: "Grâce à la magie ancestrale africaine de Maître Diamma, votre ex revient en 24 à 72 heures. Plus de 290 couples réunis avec succès.",
    icon: "RotateCcw",
    keywords: ["faire revenir ex 72h", "retour ex rapide", "magie retour amour"]
  }
];

export const magicTypes = [
  {
    id: 1,
    title: "Magie Blanche",
    description: "La magie blanche est une forme de magie positive utilisée pour attirer l'amour, la chance et le bonheur. Elle respecte le libre arbitre et apporte des énergies bienveillantes.",
    color: "white",
    benefits: ["Attirer l'amour véritable", "Protection spirituelle", "Purification énergétique", "Chance et prospérité"]
  },
  {
    id: 2,
    title: "Magie Noire",
    description: "La magie noire est une forme puissante de magie utilisée pour des situations complexes nécessitant une intervention forte. Maître Diamma la pratique avec sagesse et responsabilité.",
    color: "black",
    benefits: ["Retour affectif rapide", "Rupture de sorts", "Domination amoureuse", "Envoûtement puissant"]
  },
  {
    id: 3,
    title: "Magie Rouge",
    description: "La magie rouge est spécialement dédiée à l'amour et à la passion. Elle intensifie les sentiments et ravive la flamme dans les couples.",
    color: "red",
    benefits: ["Passion retrouvée", "Désir intense", "Fidélité éternelle", "Union des âmes"]
  }
];

export const contactInfo = {
  name: "Maître Diamma",
  phone: "+33 7 45 44 96 41",
  whatsapp: "+33745449641",
  whatsappLink: "https://wa.me/33745449641"
};

export const externalLinks = [
  { name: "Marabout DOM-TOM", url: "https://marabout-domtom.com/" },
  { name: "Marabout Africain Paris", url: "https://marabout-africain-paris.com/" },
  { name: "Marabout Belgique", url: "https://marabout-belgique.com/" },
  { name: "Marabout Bruxelles", url: "https://marabout-bruxelles.com/" }
];

export const faqData = [
  {
    question: "Qu'est-ce que le retour affectif et comment ça fonctionne ?",
    answer: "Le retour affectif est un ensemble de rituels et de pratiques spirituelles ancestrales visant à faire revenir une personne aimée ou à restaurer l'harmonie dans une relation amoureuse. Maître Diamma, grand marabout africain avec plus de 30 ans d'expérience, utilise des techniques transmises de génération en génération pour obtenir des résultats rapides et durables. Ces rituels agissent sur les énergies spirituelles pour raviver les sentiments et lever les blocages émotionnels."
  },
  {
    question: "En combien de temps peut-on voir les résultats du retour affectif ?",
    answer: "Les résultats du retour affectif varient selon la complexité de chaque situation. Avec les rituels puissants de Maître Diamma, les premiers effets se manifestent généralement entre 24 et 72 heures. Pour les cas plus complexes nécessitant des interventions approfondies, comptez jusqu'à 21 jours. Maître Diamma vous accompagne personnellement tout au long du processus jusqu'à l'obtention des résultats."
  },
  {
    question: "Quelle est la différence entre magie blanche, magie noire et magie rouge ?",
    answer: "La magie blanche utilise des énergies positives pour attirer l'amour, la protection et la purification spirituelle. La magie noire est plus puissante et intervient dans les cas complexes nécessitant une action rapide et définitive. La magie rouge est spécifiquement dédiée à l'amour, la passion et le désir. Maître Diamma choisit la méthode la plus appropriée selon votre situation pour garantir les meilleurs résultats."
  },
  {
    question: "Les rituels de retour affectif fonctionnent-ils à distance ?",
    answer: "Oui, absolument. Maître Diamma réalise des rituels de retour affectif efficaces à distance pour les clients du monde entier. Que vous soyez en France, Belgique, Suisse, Canada, Afrique ou ailleurs, les résultats sont identiques. L'énergie spirituelle ne connaît pas de frontières géographiques. Des milliers de clients internationaux ont déjà bénéficié de ses interventions à distance avec succès."
  },
  {
    question: "Comment se déroule une consultation avec Maître Diamma ?",
    answer: "La première consultation se fait par téléphone ou WhatsApp. Maître Diamma écoute attentivement votre situation, analyse les énergies en présence grâce à ses dons de voyance, et vous propose la solution la plus adaptée à votre cas. Tout se déroule dans la confidentialité absolue. Vous recevrez ensuite un accompagnement personnalisé jusqu'à l'obtention des résultats souhaités."
  },
  {
    question: "Maître Diamma est-il un vrai marabout sérieux ?",
    answer: "Oui, Maître Diamma est un grand marabout africain reconnu avec plus de 30 ans d'expérience dans le domaine du retour affectif. Il a aidé plus de 290 personnes à retrouver l'amour et le bonheur. Sa réputation repose sur des résultats concrets et des témoignages vérifiés. Il pratique son art avec sérieux, éthique et dans le respect des traditions ancestrales africaines."
  },
  {
    question: "Le retour affectif est-il garanti ?",
    answer: "Maître Diamma s'engage à mettre en œuvre tous les moyens nécessaires pour obtenir les résultats souhaités. Grâce à son expertise et à la puissance de ses rituels ancestraux, son taux de réussite est très élevé. Il vous accompagne personnellement et ajuste son intervention si nécessaire jusqu'à ce que votre ex revienne vers vous."
  },
  {
    question: "Peut-on faire revenir un ex qui est avec quelqu'un d'autre ?",
    answer: "Oui, c'est possible. Maître Diamma possède des rituels puissants spécialement conçus pour ces situations complexes. La magie noire et les envoûtements amoureux permettent de rompre les liens entre votre ex et sa nouvelle relation, puis de raviver ses sentiments pour vous. De nombreux clients ont réussi à récupérer leur ex même dans ces circonstances difficiles."
  },
  {
    question: "Quels pays Maître Diamma peut-il aider ?",
    answer: "Maître Diamma intervient dans le monde entier : France (Paris, Lyon, Marseille, Toulouse, Bordeaux...), Belgique (Bruxelles, Liège, Anvers...), Suisse (Genève, Lausanne, Zurich...), Canada (Montréal, Québec, Toronto...), ainsi que tous les pays d'Afrique, d'Europe et d'Amérique. Les consultations se font par téléphone ou WhatsApp, et les rituels sont tout aussi efficaces à distance."
  },
  {
    question: "Comment contacter Maître Diamma pour un retour affectif ?",
    answer: "Vous pouvez contacter Maître Diamma directement par téléphone au +33 7 45 44 96 41 ou par WhatsApp au même numéro. Il est disponible 7 jours sur 7 pour répondre à vos questions et vous accompagner dans votre démarche de retour affectif. N'hésitez pas à l'appeler pour exposer votre situation en toute confidentialité."
  }
];

// Génération de 150 témoignages
const prenomsFR = ["Marie", "Sophie", "Julie", "Camille", "Léa", "Emma", "Chloé", "Sarah", "Laura", "Manon", "Pauline", "Marine", "Anaïs", "Charlotte", "Lucie", "Mathilde", "Amandine", "Céline", "Émilie", "Nathalie", "Isabelle", "Valérie", "Sandrine", "Aurélie", "Stéphanie", "Pierre", "Thomas", "Nicolas", "Julien", "Antoine", "Maxime", "Alexandre", "Romain", "Guillaume", "Vincent", "David", "Sébastien", "Christophe", "François", "Laurent", "Fatou", "Aminata", "Aïssatou", "Mariam", "Kadiatou", "Fatoumata", "Oumou", "Bintou", "Awa", "Djeneba", "Mamadou", "Ibrahima", "Moussa", "Abdoulaye", "Oumar", "Seydou", "Bakary", "Cheikh", "Modou", "Aliou"];

const villesFR = ["Paris", "Lyon", "Marseille", "Toulouse", "Bordeaux", "Lille", "Nantes", "Strasbourg", "Montpellier", "Nice", "Bruxelles", "Liège", "Anvers", "Genève", "Lausanne", "Zurich", "Montréal", "Québec", "Dakar", "Abidjan", "Casablanca", "Tunis", "Libreville", "Douala", "Kinshasa", "Bamako", "Conakry", "Lomé", "Cotonou", "Ouagadougou"];

const temoignagesTextes = [
  "Grâce à Maître Diamma, mon ex est revenu en seulement 3 jours. Je n'y croyais pas au début mais les résultats sont là. Merci infiniment !",
  "Après 2 ans de séparation, j'ai retrouvé l'amour de ma vie grâce à Maître Diamma. Vraiment puissant. Je recommande à 100%.",
  "Mon mari voulait divorcer, aujourd'hui nous sommes plus heureux que jamais. Merci Maître Diamma pour ce miracle.",
  "Je suis sceptique de nature mais Maître Diamma m'a prouvé que la magie existe. Mon copain est revenu et nous allons nous marier.",
  "Résultats incroyables en 72h. Mon ex m'a appelé comme si rien ne s'était passé. Maître Diamma est un vrai professionnel.",
  "J'ai consulté plusieurs marabouts sans succès. Maître Diamma a réussi à faire revenir mon amour.",
  "La magie rouge de Maître Diamma a ravivé la passion dans mon couple. Nous vivons une seconde lune de miel.",
  "Séparé depuis 6 mois, je désespérais. Maître Diamma a tout changé en une semaine. Mon ex est revenue et m'a demandé pardon.",
  "Je recommande Maître Diamma les yeux fermés. Sérieux, efficace et à l'écoute. Mon retour affectif a fonctionné parfaitement.",
  "Ma femme était partie avec un autre homme. Grâce aux rituels de Maître Diamma, elle est revenue définitivement.",
  "Maître Diamma m'a redonné espoir quand tout semblait perdu. Aujourd'hui je vis le grand amour avec mon ex.",
  "Conseils précieux et résultats rapides. Maître Diamma mérite sa réputation.",
  "Après avoir essayé tout ce qui était possible, c'est Maître Diamma qui a réussi mon retour affectif. Éternel reconnaissant.",
  "Mon ex ne voulait plus me parler. 5 jours après le rituel de Maître Diamma, il m'a envoyé un long message d'amour.",
  "La magie blanche de Maître Diamma a purifié notre relation. Plus de disputes, que de l'amour.",
  "Je vivais un enfer depuis ma rupture. Maître Diamma m'a rendu le bonheur. Merci du fond du cœur.",
  "Travail sérieux et discret. Maître Diamma respecte la confidentialité et obtient des résultats concrets.",
  "Mon copain m'avait quittée pour sa collègue. Grâce à Maître Diamma, il est revenu et a coupé tout contact avec elle.",
  "Je ne pensais pas que c'était possible à distance mais Maître Diamma m'a prouvé le contraire.",
  "Maître Diamma est un homme de parole. Il m'avait dit 7 jours, et en 7 jours mon ex était de retour.",
  "Après 3 ans de séparation, je pensais que c'était fini. Maître Diamma a accompli l'impossible.",
  "La puissance des rituels de Maître Diamma est remarquable. Mon retour affectif a été un succès total.",
  "Je suis au Canada et Maître Diamma a réalisé le rituel à distance avec succès. Incroyable !",
  "Ma relation était au bord du gouffre. Maître Diamma l'a sauvée. Nous allons avoir un bébé.",
  "Honnête, compétent et efficace. Je recommande Maître Diamma vivement.",
  "Mon ex avait entamé une procédure de divorce. Grâce à Maître Diamma, tout est annulé, nous repartons sur de bonnes bases.",
  "Maître Diamma comprend la souffrance des cœurs brisés. Il m'a aidé avec compassion et efficacité.",
  "Résultats garantis comme promis par Maître Diamma. Mon ex est revenu amoureux comme au premier jour.",
  "Je vis en Belgique et pourtant le travail de Maître Diamma a parfaitement fonctionné.",
  "La magie noire de Maître Diamma est puissante mais utilisée avec sagesse. Résultats impressionnants."
];

// Constants for testimonial generation
const ALPHABET_SIZE = 26;
const ALPHABET_START_CODE = 65;
const TESTIMONIAL_COUNT = 150;
const FIVE_STAR_PROBABILITY = 0.1;

const generateTestimonials = () => {
  const testimonials = [];
  for (let i = 0; i < TESTIMONIAL_COUNT; i++) {
    const prenom = prenomsFR[Math.floor(Math.random() * prenomsFR.length)];
    const ville = villesFR[Math.floor(Math.random() * villesFR.length)];
    const texte = temoignagesTextes[Math.floor(Math.random() * temoignagesTextes.length)];
    const stars = Math.random() > FIVE_STAR_PROBABILITY ? 5 : 4;
    const mois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    const moisRandom = mois[Math.floor(Math.random() * mois.length)];
    const annee = Math.random() > 0.5 ? "2025" : "2024";
    
    testimonials.push({
      id: i + 1,
      name: `${prenom} ${String.fromCharCode(ALPHABET_START_CODE + Math.floor(Math.random() * ALPHABET_SIZE))}.`,
      city: ville,
      text: texte,
      stars: stars,
      date: `${moisRandom} ${annee}`,
      verified: true
    });
  }
  return testimonials;
};

export const testimonials = generateTestimonials();

export const seoKeywords = [
  // Mots-clés principaux haute compétition
  "retour affectif",
  "retour affectif rapide",
  "retour affectif puissant",
  "retour affectif efficace",
  "retour affectif sérieux",
  "retour de l'être aimé",
  "retour de l'être aimé rapide",
  "retour d'affection",
  "reconquérir son ex",
  "récupérer son ex",
  "récupérer son ex rapidement",
  "faire revenir son ex",
  "faire revenir son ex en 24h",
  "faire revenir son ex en 72h",
  // Mots-clés marabout
  "marabout",
  "marabout africain",
  "marabout sérieux",
  "grand marabout",
  "marabout retour affectif",
  "marabout paris",
  "marabout france",
  "marabout belgique",
  "marabout suisse",
  "marabout canada",
  // Mots-clés magie
  "magie blanche amour",
  "magie noire retour affectif",
  "magie rouge passion",
  "rituel amour",
  "rituel retour affectif",
  "rituel amour puissant",
  "envoûtement amoureux",
  "envoûtement retour affectif",
  // Mots-clés longue traîne
  "comment récupérer son ex",
  "comment faire revenir son ex",
  "comment reconquérir son ex",
  "voyant medium amour",
  "voyant retour affectif",
  "spécialiste retour affectif",
  "expert retour affectif",
  "maître diamma",
  "maître diamma retour affectif"
];
